import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { WorkOrderList } from '@/components/features/work-orders/work-order-list';
import { CreateWorkOrderDialog } from '@/components/features/work-orders/create-work-order-dialog';

export const Route = createFileRoute('/_authenticated/work-orders/')({
  component: WorkOrdersIndex,
});

function WorkOrdersIndex() {
  const { t } = useTranslation('workOrders');
  const [createOpen, setCreateOpen] = useState(false);

  return (
    <div className="space-y-4 sm:space-y-6">
      <div className="hidden md:flex items-center justify-between">
        <h1 className="text-xl sm:text-2xl font-bold tracking-tight">
          {t('title', { defaultValue: 'Work Orders' })}
        </h1>
      </div>
      <WorkOrderList onCreateClick={() => setCreateOpen(true)} />
      <CreateWorkOrderDialog
        hideDefaultTrigger
        open={createOpen}
        onOpenChange={setCreateOpen}
        onCreated={() => setCreateOpen(false)}
      >
        <span />
      </CreateWorkOrderDialog>
    </div>
  );
}
